import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import type { components } from '@/types/generated/openapi';

export type TUpdateCreatorProfile = components['schemas']['UpdateCreatorProfileDto'];
type TCreatorProfile = components['schemas']['ContentCreatorProfileDto'];

export const creatorProfilePatch = async (profile: TUpdateCreatorProfile): Promise<TCreatorProfile> => {
  const { data } = await api.patch<TCustomAxiosResponse<TCreatorProfile>>(apiPaths.creator.profile, profile);

  return data.data;
};

export const creatorProfilePhotoPost = async (file: File): Promise<TCreatorProfile> => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await api.post<TCustomAxiosResponse<TCreatorProfile>>(apiPaths.creator.profilePhoto, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return data.data;
};
